<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [multiPageSelect]="true"
         data-cy="manage-robots-grid">
    <ui-grid-header [search]="true">
    </ui-grid-header>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'environment_robots_modal_name' | translate"
                    [resizeable]="false"
                    property="name"
                    width="30%">
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'environment_robots_modal_type' | translate"
                    [resizeable]="false"
                    property="type"
                    width="30%">
        <ui-grid-dropdown-filter [items]="typeList">
        </ui-grid-dropdown-filter>

        <ng-template let-entry="data">
            <ng-container *ngLet="('RobotType_' +
                                    (
                                        entry.hostingType === RobotHostingType.Floating ?
                                            RobotType[entry.type] + 'Floating' :
                                            RobotType[entry.type]
                                    ) | translate) as robotTypeText">
                <span [matTooltip]="robotTypeText">
                    {{ robotTypeText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [visible]="false"
                    [title]="'robots_grid_hosting_type' | translate"
                    property="hostingType">
        <ui-grid-dropdown-filter [items]="hostingTypeList">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'environment_robots_modal_description' | translate"
                    [resizeable]="false"
                    property="description"
                    width="40%">
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>

<mat-card *ngIf="isInConflictingState$ | async"
          [uiScrollIntoView]="isInConflictingState$ | async"
          color="warn"
          data-cy="environment-robots-conflict">
    <p translate>
        environment_robots_modal_confict_warning
    </p>
</mat-card>
